import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { 
  Shield, 
  ArrowLeft,
  FileText,
  Lock,
  Eye,
  Database,
  Globe,
  Clock,
  UserCheck,
  Settings,
  Mail,
  Phone,
  AlertCircle
} from 'lucide-react';

const GizlilikPolitikasi = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative py-16 md:py-24 bg-gradient-to-br from-[#006D77] via-[#0A9396] to-[#006D77] overflow-hidden">
        <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full translate-x-1/3 translate-y-1/3"></div>
        
        <div className="max-w-4xl mx-auto px-4 relative z-10">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full px-5 py-2.5 mb-6">
              <Shield className="w-5 h-5 text-white" />
              <span className="text-white font-semibold">KVKK Uyumlu</span>
            </div>
            
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">
              Gizlilik ve Kişisel Verilerin
              <span className="block text-[#F6AD55] mt-2">Korunması Politikası</span>
            </h1>
            
            <p className="text-white/80 text-lg max-w-2xl mx-auto">
              Son güncelleme: Ocak 2025
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-20">
        <div className="max-w-4xl mx-auto px-4">
          {/* Back Button */}
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="mb-8 border-[#006D77] text-[#006D77] hover:bg-[#006D77] hover:text-white"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Geri Dön
          </Button>

          {/* Policy Content */}
          <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden">
            
            {/* Section 1: Giriş */}
            <div className="p-8 border-b border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-[#006D77] to-[#0A9396] rounded-xl flex items-center justify-center">
                  <FileText className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">1. GİRİŞ</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>HizmetGeliyo</strong> ("HizmetGeliyo" olarak anılacaktır), bu internet sitesinin 
                  ("İnternet Sitesi") kullanıcılarının çevrimiçi gizliliğini korumayı taahhüt etmektedir. 
                  Bu nedenle, bu Gizlilik Politikası, HizmetGeliyo'nun gizliliğinize ilişkin politikasını 
                  ve ayrıca İnternet Sitesini kullanırken kişisel bilgilerinizin nasıl ele alınacağını 
                  anlamanıza olanak sağlamak için yazılmıştır.
                </p>
                
                <p>
                  Bu Gizlilik Politikası ayrıca, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") 
                  kapsamında kişisel verilerinizin işlenmesine ilişkin aydınlatılmanız ve gerektiği 
                  hallerde açık rızanızın alınmasına ilişkin bilgileri içermektedir.
                </p>

                <div className="bg-[#006D77]/5 rounded-xl p-5 border border-[#006D77]/20">
                  <p>
                    Genel olarak, HizmetGeliyo hizmetlerinin kullanımı bağlamında HizmetGeliyo'ya 
                    İnternet Sitesi üzerinden sağladığınız veya HizmetGeliyo tarafından İnternet 
                    Sitesi aracılığıyla başka şekilde toplanan her türlü bilgi ve veri, HizmetGeliyo 
                    tarafından hukuka uygun, adil ve şeffaf bir şekilde işlenecektir.
                  </p>
                </div>
              </div>
            </div>

            {/* Section 2: Veri Sorumlusu */}
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-blue-50/50 to-transparent">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center">
                  <UserCheck className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">2. VERİ SORUMLUSU</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  HizmetGeliyo, işbu Gizlilik Politikasının üst kısmında tanımlandığı üzere, 
                  İnternet Sitesi üzerinden gerçekleştirilen tüm kişisel veri işlemelerinin 
                  veri sorumlusudur.
                </p>

                <div className="bg-blue-50 border border-blue-200 rounded-xl p-5">
                  <p className="font-semibold text-blue-800 mb-3">İletişim Bilgileri:</p>
                  <div className="space-y-2 text-blue-700">
                    <p className="flex items-center gap-2">
                      <Mail className="w-4 h-4" />
                      <strong>E-posta:</strong> kvkk@hizmetgeliyo.com
                    </p>
                    <p className="flex items-center gap-2">
                      <Phone className="w-4 h-4" />
                      <strong>Telefon:</strong> 0850 242 78 08
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 3: İşlenen Kişisel Veriler */}
            <div className="p-8 border-b border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-violet-600 rounded-xl flex items-center justify-center">
                  <Database className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">3. İŞLENEN KİŞİSEL VERİLER</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  İnternet Sitesini kullandığınızda HizmetGeliyo, sizi doğrudan tanımlayabilecek 
                  veya başka bilgilerle birleştirildiğinde tanımlanabilir hale getirecek kişisel 
                  verilerinizi elde eder ve işleyebilecektir.
                </p>

                <div className="bg-purple-50 border border-purple-200 rounded-xl p-5">
                  <p className="font-semibold text-purple-800 mb-3">Kimlik ve İletişim Bilgileri:</p>
                  <ul className="space-y-2 text-purple-700 ml-4">
                    <li>• Ad, Soyad</li>
                    <li>• E-posta adresi</li>
                    <li>• Telefon numarası</li>
                    <li>• Adres bilgileri</li>
                    <li>• Hizmet talep detayları</li>
                  </ul>
                </div>

                <div className="bg-gray-50 border border-gray-200 rounded-xl p-5">
                  <p className="font-semibold text-gray-800 mb-3">Tarama Verileri:</p>
                  <ul className="space-y-2 text-gray-600 ml-4">
                    <li>• IP adresi</li>
                    <li>• Konum bilgisi (ülke, şehir)</li>
                    <li>• Tarayıcı ve cihaz bilgileri</li>
                    <li>• İnternet sitesi kullanım verileri</li>
                    <li>• Çerez verileri</li>
                  </ul>
                </div>

                <div className="bg-amber-50 border border-amber-200 rounded-xl p-5">
                  <div className="flex items-start gap-3">
                    <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
                    <p className="text-amber-700 text-sm">
                      <strong>Önemli:</strong> Üçüncü kişilerin verilerini (örneğin, referanslar için 
                      iletişim bilgileri) sağlamanız halinde, yasaların öngördüğü tüm yükümlülük ve 
                      sorumlulukları üstlenmiş sayılırsınız.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 4: İşlemenin Amacı */}
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-green-50/50 to-transparent">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center">
                  <Eye className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">4. İŞLEMENİN AMACI</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white border border-gray-200 rounded-xl p-5">
                    <h4 className="font-bold text-gray-900 mb-2">🔧 Hizmet Sağlama</h4>
                    <p className="text-sm">
                      Bilgi taleplerinize yanıt vermek, hizmet taleplerini işlemek, 
                      usta eşleştirmesi yapmak ve platformumuza kaydolmanızı sağlamak.
                    </p>
                  </div>
                  
                  <div className="bg-white border border-gray-200 rounded-xl p-5">
                    <h4 className="font-bold text-gray-900 mb-2">📢 Pazarlama</h4>
                    <p className="text-sm">
                      Doğrudan pazarlama, kampanya bildirimleri, pazar araştırması 
                      ve anketlerin yürütülmesi.
                    </p>
                  </div>
                  
                  <div className="bg-white border border-gray-200 rounded-xl p-5">
                    <h4 className="font-bold text-gray-900 mb-2">⚖️ Yasal Uyumluluk</h4>
                    <p className="text-sm">
                      Yasal yükümlülüklerin yerine getirilmesi, hukuki hak taleplerinin 
                      oluşturulması ve savunulması.
                    </p>
                  </div>
                  
                  <div className="bg-white border border-gray-200 rounded-xl p-5">
                    <h4 className="font-bold text-gray-900 mb-2">📊 Analitik</h4>
                    <p className="text-sm">
                      Platform performansını optimize etmek, kullanıcı deneyimini 
                      iyileştirmek için analiz yapmak.
                    </p>
                  </div>
                  
                  <div className="bg-white border border-gray-200 rounded-xl p-5 md:col-span-2">
                    <h4 className="font-bold text-gray-900 mb-2">🛡️ Güvenlik</h4>
                    <p className="text-sm">
                      Platformun kötüye kullanımını veya dolandırıcılık faaliyetlerini 
                      önlemek ve tespit etmek, platform güvenliğini sağlamak.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 5: Veri Aktarımı */}
            <div className="p-8 border-b border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl flex items-center justify-center">
                  <Globe className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">5. KİŞİSEL VERİLERİN AKTARIMI</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  Kişisel Verileriniz aşağıda belirtilen kişi/kurumlarla paylaşılabilecektir:
                </p>

                <ul className="space-y-3 ml-4">
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-[#006D77] rounded-full mt-2 flex-shrink-0"></span>
                    <span>Hizmet sağlayıcı ustalar ve iş ortakları</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-[#006D77] rounded-full mt-2 flex-shrink-0"></span>
                    <span>Teknik altyapı ve bakım hizmeti sağlayan kuruluşlar</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-[#006D77] rounded-full mt-2 flex-shrink-0"></span>
                    <span>Ödeme işlemlerini gerçekleştiren finansal kuruluşlar</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-[#006D77] rounded-full mt-2 flex-shrink-0"></span>
                    <span>Yasal zorunluluk halinde kamu kurumları ve resmi makamlar</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-2 h-2 bg-[#006D77] rounded-full mt-2 flex-shrink-0"></span>
                    <span>Pazarlama ve analitik hizmet sağlayıcıları</span>
                  </li>
                </ul>

                <div className="bg-cyan-50 border border-cyan-200 rounded-xl p-5">
                  <p className="text-cyan-800">
                    <strong>Yurt Dışı Aktarım:</strong> Kişisel verileriniz, KVKK'nın 9. maddesi 
                    kapsamında belirlenen şartlara uygun olarak ve gerekli güvenlik önlemleri 
                    alınarak yurt dışına aktarılabilir.
                  </p>
                </div>
              </div>
            </div>

            {/* Section 6: Saklama Süresi */}
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-amber-50/50 to-transparent">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center">
                  <Clock className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">6. KİŞİSEL VERİLERİN SAKLANMASI</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  Kişisel verileriniz, işleme amaçlarının gerektirdiği süre boyunca veya 
                  ilgili mevzuatın öngördüğü süre boyunca saklanacaktır:
                </p>

                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
                    <p className="font-semibold text-amber-800">Hizmet Verileri</p>
                    <p className="text-amber-700 text-sm mt-1">
                      Hizmet ilişkisi süresince ve sonrasında yasal saklama süreleri boyunca
                    </p>
                  </div>
                  <div className="bg-orange-50 border border-orange-200 rounded-xl p-4">
                    <p className="font-semibold text-orange-800">Pazarlama Verileri</p>
                    <p className="text-orange-700 text-sm mt-1">
                      Rızanızı geri çekene kadar
                    </p>
                  </div>
                  <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
                    <p className="font-semibold text-yellow-800">Yasal Uyumluluk</p>
                    <p className="text-yellow-700 text-sm mt-1">
                      İlgili mevzuatın gerektirdiği süre boyunca (genellikle 10 yıl)
                    </p>
                  </div>
                  <div className="bg-red-50 border border-red-200 rounded-xl p-4">
                    <p className="font-semibold text-red-800">Analitik Veriler</p>
                    <p className="text-red-700 text-sm mt-1">
                      Anonimleştirilerek veya rıza geri çekilene kadar
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 7: Haklarınız */}
            <div className="p-8 border-b border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-rose-500 to-pink-600 rounded-xl flex items-center justify-center">
                  <UserCheck className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">7. İLGİLİ KİŞİNİN HAKLARI</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  KVKK'nın 11. maddesi uyarınca, ilgili kişi olarak aşağıdaki haklara sahipsiniz:
                </p>

                <div className="space-y-3">
                  {[
                    'Kişisel verilerinizin işlenip işlenmediğini öğrenme',
                    'Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme',
                    'Kişisel verilerinizin işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme',
                    'Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme',
                    'Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde düzeltilmesini isteme',
                    'KVKK\'nın 7. maddesinde öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini isteme',
                    'Düzeltme ve silme işlemlerinin, verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme',
                    'İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme',
                    'Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme'
                  ].map((hak, idx) => (
                    <div key={idx} className="flex items-start gap-3 bg-gray-50 rounded-lg p-3">
                      <div className="w-6 h-6 bg-[#006D77] rounded-full flex items-center justify-center flex-shrink-0 text-white text-xs font-bold">
                        {idx + 1}
                      </div>
                      <span className="text-sm">{hak}</span>
                    </div>
                  ))}
                </div>

                <div className="bg-rose-50 border border-rose-200 rounded-xl p-5 mt-6">
                  <p className="font-semibold text-rose-800 mb-2">Başvuru Yöntemi:</p>
                  <p className="text-rose-700 text-sm">
                    Yukarıdaki haklarınızı kullanmak için <strong>kvkk@hizmetgeliyo.com</strong> adresine 
                    yazılı olarak başvurabilir veya <strong>0850 242 78 08</strong> numaralı telefondan 
                    bizimle iletişime geçebilirsiniz.
                  </p>
                </div>
              </div>
            </div>

            {/* Section 8: Çerezler */}
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-indigo-50/50 to-transparent">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center">
                  <Settings className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">8. ÇEREZLER</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  İnternet Sitemizde çeşitli çerezler kullanılmaktadır. Çerezler, web sitemizi 
                  ziyaret ettiğinizde cihazınıza yerleştirilen küçük metin dosyalarıdır.
                </p>

                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-4">
                    <h4 className="font-bold text-indigo-800 mb-2">Zorunlu Çerezler</h4>
                    <p className="text-indigo-700 text-sm">
                      Web sitesinin düzgün çalışması için gerekli temel çerezler.
                    </p>
                  </div>
                  <div className="bg-purple-50 border border-purple-200 rounded-xl p-4">
                    <h4 className="font-bold text-purple-800 mb-2">Performans Çerezleri</h4>
                    <p className="text-purple-700 text-sm">
                      Site performansını ölçmek ve iyileştirmek için kullanılır.
                    </p>
                  </div>
                  <div className="bg-violet-50 border border-violet-200 rounded-xl p-4">
                    <h4 className="font-bold text-violet-800 mb-2">İşlevsellik Çerezleri</h4>
                    <p className="text-violet-700 text-sm">
                      Tercihlerinizi hatırlamak için kullanılır.
                    </p>
                  </div>
                  <div className="bg-fuchsia-50 border border-fuchsia-200 rounded-xl p-4">
                    <h4 className="font-bold text-fuchsia-800 mb-2">Hedefleme Çerezleri</h4>
                    <p className="text-fuchsia-700 text-sm">
                      İlgi alanlarınıza göre reklam göstermek için kullanılır.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 9: Değişiklikler */}
            <div className="p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-gray-500 to-slate-600 rounded-xl flex items-center justify-center">
                  <FileText className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">9. DEĞİŞİKLİKLER</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  Bu Gizlilik Politikası <strong>Ocak 2025</strong> tarihinde yürürlüğe girmiştir. 
                  HizmetGeliyo, bu Gizlilik Politikasını kısmen veya tamamen değiştirme veya 
                  içeriğini güncelleme hakkını saklı tutar.
                </p>

                <p>
                  HizmetGeliyo, yapılan önemli değişiklikler hakkında sizi, bunlar yürürlüğe 
                  girdiği anda (İnternet Sitesinde bir bildirim yoluyla ve e-posta bildirimleri 
                  aracılığıyla) bilgilendirecektir.
                </p>

                <div className="bg-gray-100 rounded-xl p-5">
                  <p className="text-gray-700">
                    Değişiklikler İnternet Sitesinde yayınlandığı andan itibaren bağlayıcı olacaktır. 
                    Bu nedenle, Gizlilik Politikamızı düzenli olarak kontrol etmenizi öneririz.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Box */}
          <div className="mt-12 bg-gradient-to-br from-[#006D77] to-[#0A9396] rounded-3xl p-8 text-white">
            <div className="text-center mb-6">
              <Lock className="w-12 h-12 mx-auto mb-4 opacity-80" />
              <h3 className="text-2xl font-bold mb-2">Sorularınız mı var?</h3>
              <p className="text-white/80">
                Gizlilik politikamız hakkında sorularınız için bizimle iletişime geçin.
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-4">
              <a 
                href="mailto:kvkk@hizmetgeliyo.com"
                className="flex items-center justify-center gap-3 bg-white/20 hover:bg-white/30 rounded-xl p-4 transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span className="font-semibold">kvkk@hizmetgeliyo.com</span>
              </a>
              <a 
                href="tel:08502427808"
                className="flex items-center justify-center gap-3 bg-white/20 hover:bg-white/30 rounded-xl p-4 transition-colors"
              >
                <Phone className="w-5 h-5" />
                <span className="font-semibold">0850 242 78 08</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GizlilikPolitikasi;
